import { useQuery } from '@tanstack/react-query'
import { Input, Button, Select, Empty, Spin, AutoComplete } from 'antd'
import { get } from 'lodash';
import { User, Phone, Box , RefreshCcw, Maximize } from 'lucide-react'
import moment from 'moment'
import { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Layout from '@components/Layout'
import ProductionDetailed from '@components/Modal/ProductoinDetailedDashboard'
import { http } from '@services/http'
import { calculateKvm } from '@utils/calculateKvm'
import { debouncedSet } from '@utils/debounce'
import {
	fetchDepartments,
	fetchItemsModalServices,
	fetchItemsSelect,
} from '@utils/fetchData'
import { meaningOfBg } from '@utils/switchBgProductionsTables'
import { isSameDay, isAfter, isBefore, getToday } from '@utils/time'

const DashboardWorkers = () => {
	const { t } = useTranslation()
	const { roleNames, getMe } = useSelector((state) => state.main)
	const isFilterByEmployeeDep = roleNames.includes('Sales Manager') || roleNames.includes('Cashier')

	const fetchDashboardServices = async ({ queryKey }) => {
		const [
			_,
			department,
			docNum,
			startDate,
			endDate,
			isStarted,
			isReady,
			isReadyForNextStage,
			worker,
			modalService,
			service,
		isBroken
		] = queryKey
		if (department === '') return

		try {
			const url = `api/items/dashboard/services?workerId=${worker}&isBroken=${isBroken}&department=${department}&docNum=${docNum}&startDate=${startDate}&endDate=${endDate}&isStarted=${isStarted}&isReady=${isReady}&isReadyForNextStage=${isReadyForNextStage}&itemName=${service}&modalService=${modalService}&skip=0&pageSize=1000`
			const { data } = await http.get(url)

			const formattedData = data.map((item) => {
				return {
					...item,
					potsLines: item.potsLines.map((row) => {
						const currentTime = moment()
						let positiveTimersSum = 0
						let positiveItemsLength = 0
						let negativeTimersSum = 0
						let negativeItemsLength = 0

						const docLines = row.documentLines.map((line) => {
							let remainingTime = null

							if (
								line.isStart === 'Yes' &&
								line.ready === 'No' &&
								line.startTime
							) {
								const startTime = moment(
									line.startTime,
									'HH:mm:ss',
								)
								const elapsedSeconds = currentTime.diff(
									startTime,
									'seconds',
								)
								remainingTime =
									Number(line.u_Timer) * 60 - elapsedSeconds

								if (remainingTime > 0) {
									positiveTimersSum += remainingTime
									positiveItemsLength++
								} else {
									negativeTimersSum += remainingTime
									negativeItemsLength++
								}
							}

							return {
								...line,
								timer: remainingTime,
							}
						})

						return {
							...row,
							documentLines: docLines,
							activeTimers: {
								positiveTimer: positiveTimersSum,
								positiveItemsLength: positiveItemsLength,
								negativeTimer: negativeTimersSum,
								negativeItemsLength: negativeItemsLength,
							},
						}
					}),
				}
			})

			// Aggregate timers across all dashboards for each docEntry
			const timersByDocEntry = formattedData.reduce((acc, item) => {
				item?.potsLines?.forEach((row) => {
					// If docEntry already exists, add to its values; otherwise, initialize it
					if (acc[`${row.docEntry}-${row.service}`]) {
						acc[`${row.docEntry}-${row.service}`].positiveTimer +=
							row.activeTimers.positiveTimer
						acc[
							`${row.docEntry}-${row.service}`
						].positiveItemsLength +=
							row.activeTimers.positiveItemsLength
						acc[`${row.docEntry}-${row.service}`].negativeTimer +=
							row.activeTimers.negativeTimer
						acc[
							`${row.docEntry}-${row.service}`
						].negativeItemsLength +=
							row.activeTimers.negativeItemsLength
					} else {
						acc[`${row.docEntry}-${row.service}`] = {
							positiveTimer: row.activeTimers.positiveTimer,
							positiveItemsLength:
								row.activeTimers.positiveItemsLength,
							negativeTimer: row.activeTimers.negativeTimer,
							negativeItemsLength:
								row.activeTimers.negativeItemsLength,
						}
					}
				})
				return acc
			}, {})

			setTimer(timersByDocEntry)
			return formattedData
		} catch (error) {
			console.log(error)
		}
	}

	const fetchWorkers = async ({ queryKey }) => {
		const [_] = queryKey

		try {
			const url = `api/users?role=Worker`
			const { data } = await http.get(url)
			return data
		} catch (error) {
			console.log(error)
		}
	}

	const formattedDate = getToday()

	const [docNum, setDocNum] = useState('')
	const [department, setDepartment] = useState(
		isFilterByEmployeeDep ? get(getMe, 'department', '') : '',
	)
	const [searchDocNum, setSearchDocNum] = useState('')
	const [currrentPage,setCurrentPage] = useState(0)
	const [timer, setTimer] = useState({})
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [selectedRow, setSelectedRow] = useState(null)
	const [selectedService, setSelectedService] = useState(null)

	const [isStarted, setIsStarted] = useState('')
	const [isBroken, setIsBroken] = useState('')
	const [isReady, setIsReady] = useState('')
	const [isReadyForNextStage, setIsReadyForNextStage] = useState('Yes')
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState(
		moment().add(1, 'year').endOf('year').format('YYYY-MM-DD'),
	)
	const [prodManager, setProdManager] = useState('')
	const [worker, setWorker] = useState('')
	const [service, setService] = useState('')
	const [modalService, setModalService] = useState('')
	const [serviceName, setServiceName] = useState('')
	const [searchServiceName, setSearchServiceName] = useState('')
	const [selectedServiceName, setSelectedServiceName] = useState('')

	const handleFilter = (meaning) => {
		console.log(meaning)
		if (meaning === 'Done') {
			setIsReady('Yes')
			setIsStarted('Yes')
			setIsReadyForNextStage('')
			setStartDate('')
			setEndDate(moment().endOf('year').format('YYYY-MM-DD'))
			setCurrentPage(0)
			setIsBroken('')
		}
else if (meaning === "Broken") {
			setIsReady('')
			setIsStarted('')
			setIsReadyForNextStage('')
			setStartDate('')
			setEndDate(moment().endOf('year').format('YYYY-MM-DD'))
			setCurrentPage(0)
			setIsBroken('Y')
		} else if (meaning === 'InProcess') {
			setIsReadyForNextStage('Yes')
			setIsReady('No')
			setIsStarted('Yes')
			setStartDate('')
			setEndDate(moment().endOf('year').format('YYYY-MM-DD'))
			setCurrentPage(0)
							setIsBroken('')

		} else if (meaning === 'NotStarted') {
			setIsReadyForNextStage('Yes')
			setIsReady('No')
			setIsStarted('No')
			setStartDate(moment().format('YYYY-MM-DD'))
			setEndDate(moment().endOf('year').format('YYYY-MM-DD'))
			setCurrentPage(0)
							setIsBroken('')

		} else if (meaning === 'Expired') {
			setIsReadyForNextStage('Yes')
			setIsReady('No')
			setIsStarted('No')
			setStartDate('')
			setEndDate(moment().format('YYYY-MM-DD'))
			setCurrentPage(0)
							setIsBroken('')

		} else if (meaning === 'HasToDoToday') {
			setIsReadyForNextStage('Yes')
			setIsReady('No')
			setIsStarted('No')
			setStartDate(moment().format('YYYY-MM-DD'))
			setEndDate(moment().format('YYYY-MM-DD'))
			setCurrentPage(0)
							setIsBroken('')

		} else if (meaning === 'NotReadyForNextStage') {
			setIsReadyForNextStage('No')
			setIsReady('')
			setIsStarted('')
			setStartDate('')
			setEndDate(moment().endOf('year').format('YYYY-MM-DD'))
			setCurrentPage(0)
							setIsBroken('')

		} else if (meaning === 'ClearAll') {
			setIsReadyForNextStage('')
			setIsReady('')
			setIsStarted('')
			setStartDate('')
			setEndDate(moment().endOf('year').format('YYYY-MM-DD'))
			setCurrentPage(0)
							setIsBroken('')

		} else if (meaning === 'SetAsDefault') {
			setIsReadyForNextStage('Yes')
			setIsReady('')
			setIsStarted('')
			setStartDate('')
			setEndDate(moment().endOf('year').format('YYYY-MM-DD'))
			setCurrentPage(0)
							setIsBroken('')

		}
	}

	const {
		data: productionWorker = [],
		isLoading,
		refetch,
	} = useQuery({
		queryKey: [
			'dashboardWorkers',
			department,
			docNum,
			startDate,
			endDate,
			isStarted,
			isReady,
			isReadyForNextStage,
			worker,
			modalService,
			selectedServiceName,
			isBroken
		],
		queryFn: fetchDashboardServices,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 30000,
	})

	const {
		data: workersData = [],
		isLoading: isLoadingWorkers,
		refetch: refetchWorkers,
	} = useQuery({
		queryKey: ['workers'],
		queryFn: fetchWorkers,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 30000,
	})

	const { data: itemsData = [], itemsLoading } = useQuery({
		queryKey: [
			'itemsServices',
			searchServiceName,
			'Услуги',
			'api/items/get-items',
		],
		queryFn: fetchItemsSelect,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})

	const { data: departmentData = [] } = useQuery({
		queryKey: ['departments'],
		queryFn: fetchDepartments,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: modalServiceData = [] } = useQuery({
		queryKey: ['modalService'],
		queryFn: fetchItemsModalServices,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const handleDocNumChange = (val) => {
		debouncedSet(val, setDocNum)
	}
	const handleProdManagerChanges = (val) => {
		debouncedSet(val, setProdManager)
	}

	const meaningBg = meaningOfBg(t)

	const switchUgpName = (ugpName, data) => {
		switch (ugpName) {
			case 'м':
				return (
					(2 *
						(+data.width + +data.height) *
						+data.completedDetails) /
					1000
				)

			case 'м2':
				return (
					calculateKvm(data.width, data.height) *
					data.completedDetails
				)

			case 'шт':
				return data.completedDetails

			default:
				break
		}
	}

	const filteredWorkers = workersData
	// const filteredWorkers = isFilterByEmployeeDep
	// 	? workersData.filter((worker) => worker.department == department)
	// 	: workersData

	return (
		<Layout>
			<div className="border-[2px] border-gray-200 px-5">
				<div className="flex w-fullitems-center justify-between    mr-4 mt-10  sm:mr-10 sm:mt-14 ">
					<h1 className="font-poppins text-xl font-bold text-black  sm:text-xl">
						{t('dashboardWorkers')}
					</h1>
				</div>
				<div className="mt-8 w-full border-t-[2px] border-[#E8E8E8] sm:mt-8"></div>
				<div className="flex w-full flex-col sm:flex-row flex-wrap items-start  gap-5 mt-10  sm:gap-10 ">
					<div className="flex gap-5 flex-col sm:flex-row">
						{/* {isFilterByEmployeeDep && ( */}
							<div className="flex flex-col gap-2">
								<p>{t('department')}</p>
								<Select
									className="w-[200px] h-8"
									value={department}
									onChange={setDepartment}
									options={departmentData.map(
										(department) => {
											return {
												value: +department.code,
												label: department.name,
											}
										},
									)}
									disabled={isFilterByEmployeeDep}
									filterOption={(input, option) =>
										option.label.toLowerCase().includes(input.toLowerCase())
									}
									showSearch
								/>
								{department === '' && (
										<span className="text-sm text-red-600">
											{t('selectDepartment')}
										</span>
									)}
							</div>
						{/* )} */}
					</div>
					<div className="flex flex-col gap-2">
						<p>{t('docNum')}</p>
						<Input
							value={searchDocNum}
							onChange={(e) => {
								setSearchDocNum(e.target.value)
								if (e.target.value === '') {
									setDocNum('')
								} else {
									handleDocNumChange(e.target.value)
								}
							}}
							disabled={!department}
							className="w-[250px] h-8"
							placeholder={t('docNum')}
						/>
					</div>
					<div className="flex flex-col gap-2">
						<p>{t('workerName')}</p>
						<Select
							className="w-[200px] h-8"
							options={[
								{
									value: '',
									label: t('all'),
								},
								...filteredWorkers.map((worker) => {
									return {
										value: worker.employeeId,
										label: `${worker.firstName} ${worker.lastName}`,
									}
								}),
							]}
							disabled={!department}
							onChange={setWorker}
							value={worker}
						/>
					</div>
					<div className="flex flex-col gap-2">
						<p>{t('u_ModalService')}</p>
						<Select
							className="w-[200px] h-8"
							value={modalService}
							onChange={(val) => {
								setModalService(val)
							}}
							disabled={!department}
							options={[
								{
									value: '',
									label: t('all'),
								},
								...modalServiceData.map((item) => ({
									label: item.fldValue,
									value: item.descr,
								})),
							]}
						/>
					</div>
					<div className="flex flex-col gap-2">
						<p>{t('serviceName')}</p>
						<AutoComplete
							loading={itemsLoading}
							options={itemsData?.map((item) => ({
								value: item.itemCode,
								label: item.itemName,
							}))}
							disabled={!department}
							className="min-w-[300px] h-8"
							value={serviceName}
							onSelect={async (value, label) => {
								setServiceName(label.label)
								setSearchServiceName('')
								setSelectedServiceName(label.label)
							}}
							onChange={(val) => {
								const value = val || ''
								setServiceName(value)
								debouncedSet(value, setSearchServiceName)
								if (value === '') {
									setSelectedServiceName('')
								}
							}}
							showSearch
						/>
					</div>
				</div>

				<div className="flex items-end gap-10 justify-between">
					<div className="flex gap-5 flex-wrap  mt-10">
						{[
							...meaningBg,
							{
								id: 8,
								className: 'bg-gray-600',
								meaning: t('setAsDefault'),
								key: 'SetAsDefault',
							},
						]
							.filter(
								(item) => item.key !== 'NotReadyForNextStage' ,
							)
							.map((item, index) => (
								<div
									key={index}
									className="flex gap-1 items-center cursor-pointer"
									onClick={() => handleFilter(item.key)}
								>
									<div
										className={`rounded-full ${item.className} w-[20px] h-[20px]`}
									></div>
									<span>{item.meaning}</span>
								</div>
							))}
					</div>
					<Button
						type="primary"
						disabled={!department}
						className="w-[130px] bg-[#0A4D68]  rounded-lg text-white"
						onClick={refetch}
					>
						<div className="flex items-center gap-2">
							<RefreshCcw size={16} />
							<span>{t('refetch')}</span>
						</div>
					</Button>
				</div>

				<div className="flex gap-6 overflow-x-auto pb-4 mt-10">
					{isLoading ? (
						<div className="flex items-center justify-center max-h-screen  w-full my-10">
							<Spin size="large" />
						</div>
					) : productionWorker.length > 0 ? (
						productionWorker.map((worker, index) => {
							return (
								<div
									className="space-y-4 min-w-[320px] flex-shrink-0"
									key={worker.serviceGroup}
								>
									<div className="bg-white rounded-lg shadow-xl border p-4 ">
										<h2 className="text-xl font-semibold text-center text-gray-800 capitalize">
											{worker.serviceGroup || '  .'}
										</h2>
									</div>
									<div className="flex flex-col gap-10 items-center justify-center  cursor-pointer  w-full">
										{worker.potsLines.length > 0 ? (
											worker.potsLines.map(
												(data, serviceIndex) => {
													const isReadyDocument =
														data.documentLines.every(
															(item) => {
																return (
																	item.ready ===
																	'Yes'
																)
															},
														)

													const isDocStarted =
														data.documentLines.some(
															(item) => {
																return (
																	item.isStart ===
																		'Yes' &&
																	item.ready ===
																		'No'
																)
															},
														)
													const isDocBroken =
														data.documentLines.some(
															(item) => {
																return (
																	item.u_IsBroken ===
																		'Y'
																)
															},
														)

													const isDocFinished =
														data.documentLines.every(
															(item) => {
																return (
																	item.ready ===
																	'Yes'
																)
															},
														)
													const isDocNotStartedAndAfterDocDate =
														data.documentLines.every(
															(item) => {
																return (
																	item.isStart ===
																		'No' &&
																	item.ready ===
																		'No' &&
																	isAfter(
																		data.dueDate,
																		formattedDate,
																	)
																)
															},
														)

													const isDocDateToday =
														data.documentLines.every(
															(item) => {
																return (
																	item.isStart ===
																		'No' &&
																	item.ready ===
																		'No' &&
																	isSameDay(
																		data.dueDate,
																		formattedDate,
																	)
																)
															},
														)
													const isDocDateBefore =
														data.documentLines.every(
															(item) => {
																return (
																	item.isStart ===
																		'No' &&
																	item.ready ===
																		'No' &&
																	isBefore(
																		data.dueDate,
																		formattedDate,
																	)
																)
															},
														)

													const dimensions =
														data.documentLines.reduce(
															(acc, line) => {
																if (
																	line.width &&
																	(line.height ||
																		line.hight)
																) {
																	const key = `${line.width}x${line.height || line.hight}`
																	acc[key] =
																		(acc[key] ||
																			0) +
																		1
																}
																return acc
															},
															{},
														)

													return (
														<div
															key={`${data.docEntry}-${data.service}-${Math.random()}`}
															className={`flex  w-full flex-col gap-2 shadow-lg hover:shadow-xl 	 rounded-lg   justify-center px-4  py-2 !border-l-4 border-t-2 border-t-gray-200 border-b-2 border-b-gray-200 border-r-2 border-r-gray-200 ${isDocBroken ? 'border-l-orange-400' : isDocStarted ? 'border-l-blue-400' : isDocFinished ? 'border-l-green-400' : isDocNotStartedAndAfterDocDate ? 'border-l-yellow-400' : isDocDateToday ? 'border-l-black ' : isDocDateBefore ? 'border-l-red-600' : 'border-l-[#E8E8E8] '} `}
														>
															<div className="flex  items-center justify-between gap-2 mt-2">
																<div className="flex flex-col gap-2">
																	<span className=" text-gray-900 font-bold text-xl">
																		{t(
																			'docNum',
																		)}
																		{' : '}
																		{
																			data.salesOrderDocNum
																		}
																	</span>
																	<div className="flex gap-2">
																		<div className="text-blue-700 bg-blue-100 rounded-xl p-1 px-2 font-bold text-sm">
																			{
																				data.serviceDescription
																			}
																		</div>
																		<div className="text-blue-700 bg-blue-100 rounded-xl p-1 px-2 font-bold text-sm">
																			{
																				data
																					?.documentLines[0]
																					?.u_ModalService
																			}
																		</div>
																	</div>
																</div>
																<div className="flex items-center justify-end mr-2">
																	<div
																		className={`rounded-full size-4 ${isDocBroken ? 'bg-orange-600' : isDocStarted ? 'bg-blue-400' : isDocFinished ? 'bg-green-400' : isDocNotStartedAndAfterDocDate ? 'bg-yellow-400' : isDocDateToday ? 'bg-black ' : isDocDateBefore ? 'bg-red-600' : 'bg-[#E8E8E8] '} `}
																	></div>
																</div>
															</div>

															<div className="flex flex-col gap-3 mt-2">
																<div className="flex items-center gap-2">
																	<User
																		size={
																			20
																		}
																		color="gray"
																	/>
																	<div className="flex gap-2">
																		<span className="text-sm text-gray-600">
																			{`${t('cardName')} : `}
																		</span>
																		<span className="text-sm text-gray-900">
																			{
																				data.cardName
																			}
																		</span>
																	</div>
																</div>
																<div className="flex items-center gap-2">
																	<Phone
																		size={
																			18
																		}
																		color="gray"
																	/>
																	<div className="flex gap-2">
																		<span className="text-sm text-gray-600">
																			{`${t('phoneNum')} : `}
																		</span>
																		<span className="text-sm text-gray-900">
																			{
																				data.cellular
																			}
																		</span>
																	</div>
																</div>
																<div className="flex items-center gap-2">
																	<User
																		size={
																			20
																		}
																		color="gray"
																	/>
																	<div className="flex gap-2">
																		<span className="text-sm text-gray-600">
																			{`${t('slpName')} : `}
																		</span>
																		<span className="text-sm text-gray-900">
																			{
																				data.slpName
																			}
																		</span>
																	</div>
																</div>
																{/* <div className="flex items-center gap-2">
																	<User
																		size={
																			20
																		}
																		color="gray"
																	/>
																	<div className="flex gap-2">
																		<span className="text-sm text-gray-600">
																			{`${t('workerName')} : `}
																		</span>
																		<span className="text-sm text-gray-900">
																			{
																				data.workerName
																			}
																		</span>
																	</div>
																</div>
																<div className="flex items-center gap-2">
																	<User
																		size={
																			20
																		}
																		color="gray"
																	/>
																	<div className="flex gap-2">
																		<span className="text-sm text-gray-600">
																			{`${t('prodManager')} : `}
																		</span>
																		<span className="text-sm text-gray-900">
																			{
																				data.prodManager
																			}
																		</span>
																	</div>
																</div> */}
																<div className="flex items-center gap-2">
																	<Box
																		size={
																			20
																		}
																		color="gray"
																	/>
																	<div className="flex gap-2">
																		<span className="text-sm text-gray-600">
																			{`${t('item')} : `}
																		</span>
																		<span className="text-sm text-gray-900">
																			{
																				data.itemName
																			}
																		</span>
																	</div>
																</div>
																{Object.keys(
																	dimensions,
																).length >
																	0 && (
																	<div className="flex items-start gap-2">
																		<Maximize
																			size={
																				20
																			}
																			color="gray"
																			className="mt-0.5"
																		/>
																		<div className="flex flex-col gap-1">
																			<span className="text-sm text-gray-600">
																				{`${t('size')} :`}
																			</span>
																			{Object.entries(
																				dimensions,
																			).map(
																				([
																					dim,
																					count,
																				]) => (
																					<span
																						key={dim}
																						className="text-sm text-gray-900 font-bold"
																					>
																						{dim} - {count} шт
																					</span>
																				),
																			)}
																		</div>
																	</div>
																)}
															</div>

															<div className="grid grid-cols-2 gap-2 mt-2">
																<div className="bg-gray-100 rounded-lg p-2 text-center">
																	<div className="text-2xl font-bold text-gray-800">
																		{
																			data.serviceCount
																		}
																	</div>
																	<div className="text-xs text-gray-600">
																		{t(
																			'totalDetail',
																		)}
																	</div>
																</div>
																<div className="bg-green-100 rounded-lg p-2 text-center">
																	<div className="text-2xl font-bold text-green-800">
																		{
																			data.completedDetails
																		}
																	</div>
																	<div className="text-xs text-green-600">
																		{t(
																			'completedDetail',
																		)}
																	</div>
																</div>
																<div className="bg-blue-100 rounded-lg p-2 text-center">
																	<div className="text-2xl font-bold text-blue-800">
																		{
																			data.detailsInProcess
																		}
																	</div>
																	<div className="text-xs text-blue-600">
																		{t(
																			'inProcess2',
																		)}
																	</div>
																</div>
																<div className="bg-yellow-100 rounded-lg p-2 text-center">
																	<div className="text-2xl font-bold text-yellow-800">
																		{data.ostatka -
																			data.detailsInProcess }
																	</div>
																	<div className="text-xs text-yellow-600">
																		{t(
																			'notStarted',
																		)}
																	</div>
																</div>
															</div>
		<div className="bg-orange-100 rounded-lg p-2 text-center">
																	<div className="text-2xl font-bold text-orange-800">
																		{
																			data.brokenDetails
																		}
																	</div>
																	<div className="text-xs text-orange-600">
																		{t(
																			'isBroken',
																		)}
																	</div>
																</div>
															<div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg p-2 border border-green-200">
																<div className="text-center">
																	<div className="text-lg font-bold text-green-800">
																		{switchUgpName(
																			data.unitMsr,
																			data,
																		)}{' '}
																		{
																			data.unitMsr
																		}
																	</div>
																	<div className="text-xs text-green-600">
																		{t(
																			'completedDetail',
																		)}
																	</div>
																</div>
															</div>

															<div className="flex items-center justify-end gap-2 mt-1 mb-1">
																<button
																	className="ring-offset-background text-white focus-visible:outline-hidden focus-visible:ring-ring inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 text-primary-foreground hover:bg-primary/90 h-10 px-4 py-1 w-full bg-gradient-to-r from-blue-500 to-teal-500 hover:from-blue-600 hover:to-teal-600"
																	type="primary"
																	onClick={() => {
																		setIsModalOpen(
																			true,
																		)
																		setSelectedRow(
																			data,
																		)
																		setSelectedService(
																			data.service,
																		)
																		console.log(
																			'docLines',
																			data,
																		)
																		// setModalVisible(true)
																	}}
																>
																	{t(
																		'seeDetailed',
																	)}
																</button>
															</div>
														</div>
													)
												},
											)
										) : (
											<div className="flex items-center justify-center max-h-screen  w-full my-10">
												<Empty
													image={
														Empty.PRESENTED_IMAGE_SIMPLE
													}
													// description={
													// 	<p>
													// 		Customize{' '}
													// 		<a href="#API">
													// 			Description
													// 		</a>
													// 	</p>
													// }
												/>
											</div>
										)}
									</div>
								</div>
							)
						})
					) : (
						<div className="flex items-center justify-center max-h-screen  w-full my-10">
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						</div>
					)}
				</div>
			</div>

			<ProductionDetailed
				visible={isModalOpen}
				data={selectedRow}
				onClose={() => setIsModalOpen(false)}
				service={selectedService}
			/>
		</Layout>
	)
}

export default DashboardWorkers
